// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation ReportEditingStatusMutation(
    $input: ReportEditingStatusInput!
    ) {
        ReportEditingStatus(input: $input) {
            sessions {
                id
                user
                object
            }
            clientMutationId
            error
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment,
        {
            mutation,
            variables: {
                input: params,
            },
            onCompleted: (res) => {
                const response = res.ReportEditingStatus;
                if (response.error !== null) {
                    callback(response.error, null);
                    return;
                }
                callback(null, response.sessions);
            },
            onError: (error) => {
                console.warn('error');
                console.warn(error);
                callback(error, null);
            },
        },
    );
}



// WEBPACK FOOTER //
// src/mutations/ReportEditingStatus.js